import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import useStyles from './AlarmLabel.styles';
import { Alarm } from 'types/Organizer';
import { FormattedMessage } from 'react-intl';

type AlarmLabelPureProps = {
  messageId: string;
};

const AlarmLabelPure = ({ messageId }: AlarmLabelPureProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <NotificationsActiveIcon className={classes.icon} />

      <span className={classes.label} data-testid="alarm-label">
        <FormattedMessage id={messageId} />
      </span>
    </div>
  );
};

const getMessageId = (alarm: Alarm): string => {
  switch (alarm) {
    case Alarm.BEFORE_15_MIN:
      return 'alarm.BEFORE_15_MIN';
    case Alarm.BEFORE_30_MIN:
      return 'alarm.BEFORE_30_MIN';
    case Alarm.BEFORE_60_MIN:
      return 'alarm.BEFORE_60_MIN';
    case Alarm.ON_TIME:
      return 'alarm.ON_TIME';
    default:
      return '';
  }
};

type AlarmLabelProps = {
  alarm: Alarm;
};

const AlarmLabel = ({ alarm }: AlarmLabelProps): JSX.Element | null => {
  if (alarm === Alarm.NO_ALARM) {
    return null;
  }

  const messageId = getMessageId(alarm);

  return <AlarmLabelPure messageId={messageId} />;
};

export default AlarmLabel;
